
import { Fragment, useState, useRef} from 'react'
import { Dialog, Transition, } from '@headlessui/react'
import Navbar from '../components/Navbar'

import { AppConfigurationClient } from '@azure/app-configuration'
//import reports from '../reportsConfig.json'
import { models, util } from 'powerbi-client';
import { PowerBIEmbed, } from 'powerbi-client-react';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import '../css/Embed.css';
import {
  HomeIcon,
  PrinterIcon,
  XMarkIcon,
  PhotoIcon
} from '@heroicons/react/24/outline';
import {
  Link
} from "react-router-dom";
import { useEffect } from 'react';

import { loginRequest } from '../authConfig';
import ExportReportButton  from './ExportReportButton';

const {REACT_APP_CONFIG_KEYS, REACT_APP_CONFIG_ENDPOINT, } = process.env

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: true },
 
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

 
export default function Dashboards() {
const [embeddedReport, setEmbeddedReport] = useState(null)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { instance } = useMsal();
  const [accessToken, setAccessToken] = useState(null);
  const isAuthenticated = useIsAuthenticated();
  const [selectedReport, setSelectedReport] = useState('');
  const [reportLayout, setReportLayout] = useState(models.LayoutType.MobileLandscape);
  const [appConfigVars, setAppConfigVars] = useState({});
  const [width, setWidth] = useState(window.innerWidth);
  const [authenticated, setAuthenticated] = useState(false);
  const [exportToken, SetExportToken] = useState(null);
  const [activeTab, setActiveTab] = useState('Broker Benchmark');
  const [isInprogress, setInProgress] = useState(false);
  const [reportFilters, setReportFilters] = useState([])
  const [reportInfo, setReportInfo] = useState([]);
  const [exportRequest, setExportRequest] = useState();
  
  const {REACT_APP_CONFIG_ENDPOINT, REACT_APP_EXPORT_ENDPOINT} = process.env
  
  // --------- Set State -------------------

  
  const [pbiReportConfig, setReportConfig] = useState({
    type: 'report',
    embedUrl: undefined,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false
        }
        
      },
      layoutType:reportLayout
    },
  });
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
}

useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
}, []);

const isMobile = width <= 768;
 useEffect(() => {
 
  if(isMobile){

    setReportConfig({...pbiReportConfig, settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false
        }
      },
      layoutType:models.LayoutType.MobilePortrait
    }})
 
  }else if(!isMobile){
  
    setReportConfig({...pbiReportConfig, settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false
        }
      },
      layoutType:models.LayoutType.MobileLandscape
    }})
    
  }


 }, [width])

 useEffect(() => {
 }, [isMobile])
  const eventHandlersMap = new Map([
    ['loaded', function () {

    }],
    ['rendered', function () {
    }]
  ]);

const client = new AppConfigurationClient(
    `Endpoint=${REACT_APP_CONFIG_ENDPOINT}`
  );



  async function getKeyValues(keys) {
    let tempMap = {};
    let tempArray = [];
    let tempObject = {};
    
    for(var i = 0; i<keys.length;i++){
        let retrievedSetting = await client.getConfigurationSetting({
            key:keys[i]
          });
        if (keys[i].includes('REACT_APP')) {
          tempMap[keys[i].split('REACT_APP_')[1]] = retrievedSetting.value
        } else {
          let name = keys[i].substring(keys[i].lastIndexOf("_") + 1);
          tempObject[name] = retrievedSetting.value;
          if (name === 'NAME') {
            tempArray.push(tempObject);
            tempObject = {};
          }
          
        }
     
    }
    // Get the List of Reports from the config variables.
    
    if (selectedReport === '') {
      setReportInfo(tempArray);
      setSelectedReport(tempArray[0]?.ID);
    }
    if (accessToken) {
      await mockSignIn(tempMap);
    }
    
  }

  


//function to request access token needed for ms graph requests
 async function RequestAccessToken() {
  if(isAuthenticated){
    instance.setActiveAccount(instance.getAllAccounts()[0])

    let account = instance.getActiveAccount()
    window.sessionStorage.setItem('account',JSON.stringify(account))
    
        const request = {
            ...loginRequest,
            account: account
        };

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    await instance.acquireTokenSilent(request).then((response) => {
      
        setAccessToken(response?.accessToken);
        setAuthenticated(true);
        
      
    }).catch((e) => {
         instance.acquireTokenPopup(request).then((response) => {
            setAccessToken(response?.accessToken);
        });
    });
    
    const keys = REACT_APP_CONFIG_KEYS?.split(',');
    await getKeyValues(keys);
  }
  
 }
 

//When an access token is set, we make a request to ms graph for the user's groups
 useEffect(() => {
  if(isAuthenticated){
    console.log(instance.getActiveAccount())
    instance.setActiveAccount(instance.getAllAccounts()[0])
    RequestAccessToken();
  }
   

 }, [isAuthenticated, selectedReport, accessToken])

 
  // ---------Sign in -------------------
  //Config for power-bi based on selected report
  const mockSignIn = async (settings) => {

    const exportTokenCall = await fetch(REACT_APP_EXPORT_ENDPOINT , {
      headers: {
        'Cache-Control': 'no-cache, no-store',
        'Expires': '0',
        'Pragma': 'no-cache',
        'mstoken':accessToken
      }
    });
    const TokenResponse = await exportTokenCall.json();

    SetExportToken(TokenResponse.headers.Authorization.split(' ') [1]);
    console.log(settings)
    const sampleReportUrl = `${settings?.FUNCTION_ENDPOINT}api/getPBITokenTDCSI?code=${settings?.EMBED_KEY}&reportId=${selectedReport}`;
    setAppConfigVars(settings);
    if (accessToken && selectedReport) {
      const reportConfigResponse = await fetch(sampleReportUrl, {
        headers: {
          'Cache-Control': 'no-cache, no-store',
          'Expires': '0',
          'Pragma': 'no-cache',
          'mstoken':accessToken
        }
      });


      if (!reportConfigResponse.ok) {
        console.error(`Failed to fetch config for report. Status: ${reportConfigResponse.status} ${reportConfigResponse.statusText}`);
        return;
      }

      const reportConfig = await reportConfigResponse.json();
      
      setReportConfig({
        ...pbiReportConfig,
        //embedUrl: reportConfig.EmbedUrl,
        embedUrl: reportConfig.embedUrl[0].embedUrl,
        accessToken: reportConfig.accessToken
        //accessToken: reportConfig.EmbedToken.Token
      });
      setInProgress(false);
    }

  };

  //handles msal user logout
  const handleLogout = () => {
     window.sessionStorage.clear()
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }
  //function handles a user selecting a report from filtered reports
function handleReportChange(name, id){
  setSelectedReport(id);
  setActiveTab(name);
  setInProgress(true);
}

const handleReport = async (embeddedReport) => {
  setEmbeddedReport(embeddedReport);
  setExportRequest({
    reportId: selectedReport,
    format: 'png'
  });
  embeddedReport.allowedEvents.forEach((eventName) => {
    embeddedReport.on(eventName, (event) => {console.log(eventName); console.log(event);console.log(embeddedReport)});
  });

  

}

const handleBookmark = async(event) => {
  const reportFilters = await embeddedReport.getFilters();
    const simpleFilters = [];
    reportFilters.forEach(filter => {
      const target = `${filter.target.column}`;

      if (filter.filterType === 1) { // Basic filter
        simpleFilters.push(filter.target.table+ '/' + filter.target.column + ' ' + filter.operator+ ' ' +`'${filter.values[0]}'`);
      } else if (filter.filterType === 0) { // Advanced filter
        const condition = filter.conditions[0]; // Assuming single condition
        simpleFilters.push(filter.target.table+ '/' + filter.target.column + ' ' + condition.operator+ ' ' +`'${condition.value}'`);
      }
    });
    console.log(simpleFilters);
    // setReportFilters(simpleFilters);

    
    const bookMarkResult = await embeddedReport.bookmarksManager.capture({
      personalizeVisuals: true,
    });
    const currentPage = await embeddedReport.getActivePage();
    return {
      exportRequest: {
        ...exportRequest,
        powerBIReportConfiguration: {
          defaultBookmark: {state: bookMarkResult.state},
          pages: [{
            bookmark:{
              state: bookMarkResult.state
            },
            pageName: currentPage.name,

          }]
        }
      },
      filters: simpleFilters
    }

      

}

 return (
    <AuthenticatedTemplate>
      <div>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog as="div" className="relative z-40 md:hidden" onClose={setSidebarOpen}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-100 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-gray-800">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                      <button
                        type="button"
                        className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="h-0 flex-1 overflow-y-auto pt-5 pb-4">
                    <Link to='/' className="flex flex-shrink-0 items-center px-4">
                      <img
                        className="h-8 w-auto"
                        src={""}
                        alt="Your Company"
                      />
                    </Link>
                    <nav className="mt-5 space-y-1 px-2">
                      {navigation.map((item, index) => (
                        <a
                          key={index}
                          href={item.href}
                          className={classNames(
                            item.current
                              ? 'bg-gray-900 text-white'
                              : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                            'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                          )}
                        >
                          <item.icon
                            className={classNames(
                              item.current ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300',
                              'mr-4 flex-shrink-0 h-6 w-6'
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </a>
                      ))}
                    </nav>
                  </div>
                  <div className="flex flex-shrink-0 bg-gray-700 p-4">
                    <a href="#" className="group block flex-shrink-0">
                      <div className="flex items-center">
                        <div>
                          <img
                            className="inline-block h-10 w-10 rounded-full"
                            src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                            alt=""
                          />
                        </div>
                        <div className="ml-3">
                          <Link to="/" className="whitespace-nowrap text-base font-medium
             text-white hover:text-gray-900" onClick={handleLogout}>
                            Sign Out
                          </Link>
                        </div>
                      </div>
                    </a>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
              <div className="w-14 flex-shrink-0">{/* Force sidebar to shrink to fit close icon */}</div>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
      
        <div className="flex flex-1 flex-col ">
         <Navbar/>
          <main className="flex-1 ">
            <div className="py-6">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">Dashboard</h1>
              </div>
              <div className="mx-auto max-w-7xl  px-4 sm:px-6 md:px-8 w-full">
                <div className="py-4">
                </div>
                

                <div className="mb-4 border-b border-gray-200">
                  <ul className="flex flex-wrap -mb-px text-sm font-medium text-center" id="default-tab" data-tabs-toggle="#default-tab-content" role="tablist">
                    {reportInfo.length ? reportInfo.map((report, index) => (
                      <li className="me-2" role="presentation" key={index}>
                          <button className={`inline-block p-4 border-b-2 rounded-t-lg ${selectedReport === report?.ID ? 'border-b-2 border-blue-500' : ''}`} 
                          data-tabs-target="#report-holder" type="button" role="tab" aria-controls="profile" aria-selected="false"
                          onClick={() => reportInfo.length > 0 && handleReportChange(report?.NAME, report.ID)}
                          >{report?.NAME}</button>
                      </li>
                    )): <>Loading ...</>}
                      
                     
                  </ul>
                </div>  
                <div id="default-tab-content">
                  <div className={`p-4 rounded-lg`} id="report-holder" role="tabpanel">
                  {(!isInprogress && reportInfo.length) ? <div  >
                    <div className='w-full p-2 flex justify-between w-4/5'>
                                   
                      <div className='flex items-end justify-end text-slate-600 mr-8 mx-auto cursor-pointer hover:underline ' onClick={() => embeddedReport?.print() }>
                        Export to PDF<PrinterIcon  className='w-6 h-6 p2 hover:text-slate-300 cursor-pointer'/>
                      </div>

                      <div className='flex items-end justify-end text-slate-600 mx-8 hover:underline'>
                        <ExportReportButton 
                            accessToken={exportToken} 
                            reportId={selectedReport} 
                            bookmarkEvent={handleBookmark}
                          />
                      </div>
                        
                    </div>
                    <PowerBIEmbed
                          id = 'powerbi'
                          embedConfig={pbiReportConfig}
                          eventHandlers={eventHandlersMap}
                          cssClassName="report-style-class"
                          getEmbeddedComponent={handleReport}
                          service={window.powerbi.service}
                      /> 
                    </div>: null}
                  </div>
                </div>
              </div>
           
            </div>
          </main>
        </div>
      </div>
    </AuthenticatedTemplate>
  )
}
